import { LoadingButton } from '@mui/lab';
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Transition } from '../../components/Transition';
import { NumericFormatCustom } from '../../components/NumericCustomFormatter';
import { MuiColorInput } from 'mui-color-input';

interface IProps {
  toggle: boolean;
  onClose: () => void;
  values: any;
  handleSubmit: () => void;
  setFieldValue: (key: string, value: any) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
  errors: any;
  touched: any;
  isSubmitting: boolean;
  resetForm: () => void;
}

const CountryFormModal: React.FC<IProps> = ({
  toggle,
  onClose,
  errors,
  touched,
  values,
  isSubmitting,
  setFieldValue,
  handleChange,
  handleSubmit,
  resetForm,
}) => {
  return (
    <Dialog
      fullWidth
      open={toggle}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => {
        resetForm();
        onClose();
      }}
      aria-describedby='alert-dialog-slide-description'
    >
      <DialogTitle sx={{ mt: -0.5, mb: -0.5 }}>Color</DialogTitle>
      <form
        onSubmit={handleSubmit}
        autoComplete='off'
      >
        <DialogContent dividers>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              sm={12}
            >
              <MuiColorInput
                label='Select Color Code'
                format='hex'
                value={values?.colorCode}
                onChange={(newColor: string) =>
                  setFieldValue('colorCode', newColor)
                }
                error={Boolean(errors.colorCode && touched.colorCode)}
                helperText={
                  Boolean(errors.colorCode && touched.colorCode) &&
                  errors.colorCode
                }
                sx={{ width: '100%' }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
            >
              <TextField
                id='labelEn'
                name='labelEn'
                label='English'
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.labelEn}
                error={Boolean(errors.labelEn && touched.labelEn)}
                helperText={
                  Boolean(errors.labelEn && touched.labelEn) && errors.labelEn
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
            >
              <TextField
                id='labelAr'
                name='labelAr'
                label='Arabic'
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.labelAr}
                error={Boolean(errors.labelAr && touched.labelAr)}
                helperText={
                  Boolean(errors.labelAr && touched.labelAr) && errors.labelAr
                }
              />
            </Grid>
            {/* <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                id='colorType'
                name='colorType'
                label='Color Type'
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.colorType}
                error={Boolean(errors.colorType && touched.colorType)}
                helperText={
                  Boolean(errors.colorType && touched.colorType) &&
                  errors.colorType
                }
              />
            </Grid> */}
            <Grid
              item
              xs={12}
              sm={12}
            >
              <TextField
                id='position'
                name='position'
                label={'Position'}
                fullWidth
                variant='outlined'
                onChange={handleChange}
                value={values.position}
                InputProps={{
                  inputComponent: NumericFormatCustom as any,
                }}
                error={Boolean(errors.position && touched.position)}
                helperText={
                  Boolean(errors.position && touched.position) &&
                  errors.position
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    color='primary'
                    name='activeState'
                    onChange={(e) =>
                      setFieldValue('activeState', e.target.checked)
                    }
                    checked={values.activeState}
                  />
                }
                label={'Active Status'}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              resetForm();
              onClose();
            }}
            variant='outlined'
          >
            {'Cancel'}
          </Button>
          <LoadingButton
            type='submit'
            loading={isSubmitting}
            variant='contained'
          >
            {'Save'}
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CountryFormModal;
